<template>
    <div class="row" v-if="productInfo != null">
        <div class="col-12">
            <nav>
                <ul class="breadcrumb">
                    <li>
                        <router-link class="btn-link" tag="a" to="/"><span>{{baseInfo.ShopName}}</span></router-link>
                    </li>
                    <li>
                        <router-link class="btn-link" tag="a" :to="{ path: '/filter', query: { SubGroupId: productInfo.SubGroupId , SubGroupName: productInfo.SubGroupTitle }}"><span>{{productInfo.GroupTitle}}</span></router-link>
                    </li>
                    <li>
                        <router-link class="btn-link" tag="a" :to="{ path: '/filter', query: { SubGroupId: productInfo.SubGroupId , SubGroupName: productInfo.SubGroupTitle }}"><span>{{productInfo.SubGroupTitle}}</span></router-link>
                    </li>
                    <li>
                        <a href="#"><span>{{productInfo.Name}} </span></a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            productInfo: {
                type: Object,
            },
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        }
    }
</script>

<style scoped> 
    @media only screen and (min-width: 0px) and (max-width: 640px) {
    }
</style>